import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const TEMPORARY_PERMISSION_DELETE_RESOURCE = "temporary-permission" as const;
export const TEMPORARY_PERMISSION_DELETE_API_PATH = `/v1/${TEMPORARY_PERMISSION_DELETE_RESOURCE}/{uuid}` as const;

export type TemporaryPermissionDeleteResponse =
  paths[typeof TEMPORARY_PERMISSION_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useTemporaryPermissionDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TemporaryPermissionDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<TemporaryPermissionDeleteResponse>(
        `/v1/${TEMPORARY_PERMISSION_DELETE_RESOURCE}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [TEMPORARY_PERMISSION_DELETE_RESOURCE],
      });
    },
  });
};
